import type { Candidate } from '@axiom/validation';
import { CurrencyUtil } from '@axiom/utils';

export const DISCOUNT_PERCENTAGES = [5, 10, 15, 20, 25] as const;

export const WorkFeedInterestUtil = {
  /**
   * Calculates the discounted hourly rate for display purposes only.
   * IMPORTANT: This calculation is duplicated in the backend for security.
   * See: CandidatesOpportunityService#calculateOpenToLowerEscCompensationAmount
   */
  formatDiscountedRateLabel: ({
    discountPercentage,
    isPremium,
    candidate,
  }: {
    discountPercentage: number;
    isPremium: boolean;
    candidate: Candidate;
  }): string => {
    const { compHourlyPremium, hourlyCompensation, currencyType } = candidate;

    if (!compHourlyPremium || !hourlyCompensation || !currencyType) {
      return '';
    }

    const rateTypeLabel = isPremium ? 'Premium Hourly' : 'Standard Hourly';
    const hourlyRate = isPremium
      ? compHourlyPremium
      : Number.parseFloat(hourlyCompensation);
    const discountedRate = hourlyRate * (1 - discountPercentage / 100);
    const formattedRate = CurrencyUtil.getFormattedCurrency({
      value: discountedRate,
      currencyCode: currencyType,
    });

    return `(${rateTypeLabel}: ${formattedRate})`;
  },

  getCompensationDiscountOptions: ({
    isPremium,
    candidate,
  }: {
    isPremium: boolean;
    candidate: Candidate;
  }) => {
    return DISCOUNT_PERCENTAGES.map(percentage => ({
      value: percentage,
      label: `Up to ${percentage}% ${WorkFeedInterestUtil.formatDiscountedRateLabel({ discountPercentage: percentage, isPremium, candidate })}`,
    }));
  },
};
